function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "8.042%",
  y1: "0%",
  x2: "65.682%",
  y2: "23.865%",
  id: "loader_svg__a"
}, React.createElement("stop", {
  stopColor: "#30576E",
  stopOpacity: 0,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#30576E",
  stopOpacity: 0.631,
  offset: "63.146%"
}), React.createElement("stop", {
  stopColor: "#30576E",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M36 18c0-9.94-8.06-18-18-18",
  stroke: "url(#loader_svg__a)",
  strokeWidth: 2
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "0.9s",
  repeatCount: "indefinite"
})), React.createElement("circle", {
  fill: "#30576E",
  cx: 36,
  cy: 18,
  r: 1
}, React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "0.9s",
  repeatCount: "indefinite"
})));

var SvgLoader = function SvgLoader(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38
  }, props), _ref, _ref2);
};

export default SvgLoader;